import {
  Box,
  BoxProps,
  Flex,
  FlexProps,
  IconButtonProps,
  useBreakpointValue,
} from "@chakra-ui/react";
import { Children, useState } from "react";
import { FreeMode, Mousewheel } from "swiper/modules";
import {
  Swiper,
  SwiperClass,
  SwiperProps,
  SwiperSlide,
  SwiperSlideProps,
} from "swiper/react";
import { useIsDesktop, useIsMobile } from "~/lib/hooks";
import { CarouselButton } from "./CarouselButton";

type Props = FlexProps & {
  swiper_props?: BoxProps & SwiperProps;
  slide_props?: SwiperSlideProps;
  button_props?: IconButtonProps;
  showNav?: boolean;
};

export const Carousel = ({
  children,
  swiper_props,
  slide_props,
  button_props,
  showNav = true,
  ...props
}: Props) => {
  const [swiper, setSwiper] = useState<SwiperClass>();
  const isDesktop = useIsDesktop();
  const isMobile = useIsMobile();
  const arrayChildren = Children.toArray(children);
  const minWidth = useBreakpointValue({ md: "300px", lg: "242px" });
  return (
    <Flex align="center" {...props}>
      {showNav && arrayChildren.length > 3 && (
        <CarouselButton swiper={swiper} {...button_props} />
      )}
      <Box
        w="100%"
        onSwiper={setSwiper}
        as={Swiper}
        slidesPerView={isDesktop ? 3 : isMobile ? 1 : 2}
        spaceBetween={"16px"}
        display={"flex"}
        alignItems={"center"}
        mx={{ base: 0, lg: 8 }}
        px={{ base: 8, lg: 0 }}
        modules={[FreeMode, Mousewheel]}
        freeMode={isMobile}
        centeredSlides={arrayChildren.length === 1}
        {...swiper_props}
      >
        {Children.map(arrayChildren, (child) => (
          <SwiperSlide
            style={{
              width: "auto",
              height: "auto",
              minWidth,
            }}
            {...slide_props}
          >
            <>{child}</>
          </SwiperSlide>
        ))}
      </Box>
      {showNav && arrayChildren.length > 3 && (
        <CarouselButton next swiper={swiper} {...button_props} />
      )}
    </Flex>
  );
};
